// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "WETH",
    token: "0x4200000000000000000000000000000000000006",
    fToken: "0x9272D6153133175175Bc276512B2336BE3931CE9",
  },
  {
    symbol: "USDC",
    token: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    fToken: "0xf42f5795D9ac7e9D757dB633D693cD548Cfd9169",
  },
  {
    symbol: "wstETH",
    token: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
    fToken: "0x896E39f0E9af61ECA9dD2938E14543506ef2c2b5",
  },
  {
    symbol: "EURC",
    token: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
    fToken: "0x1943FA26360f038230442525Cf1B9125b5DCB401",
  },
  {
    symbol: "sUSDS",
    token: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
    fToken: "0xf62e339f21d8018940f188F6987Bcdf02A849619",
  },
  {
    symbol: "GHO",
    token: "0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee",
    fToken: "0x8DdbfFA3CFda2355a23d6B11105AC624BDbE3631",
  },
] as const
